<template>
  <label :for="elId" :class="myclasses">
    <div v-html="label" class="font-weight-bold"></div>
    <!-- {{status}} -->
    <span v-if="status_list[status].input_message" class="text-warning font-italic small">
      &emsp;{{labels.status_message?.[status_list[status]?.input_message]}}
    </span>
    <div v-if="popup_aecom && popupUrl">

      <b-btn pill variant="info" size="sm" 
        :href="popupUrl" 
        v-if="!isNative"
        target="_blank">
        <span class="glyphicon glyphicon-question-sign"></span>
      </b-btn>
    
      <b-btn pill variant="info" size="sm" v-if="isNative"
        @click.prevent="showModal = true"
      ><span class="glyphicon glyphicon-question-sign"></span></b-btn>
      <b-modal v-if="isNative" v-model="showModal" hide-footer centered size="lg" @hidden="isZoomed = false" body-class="p-1">
        <div style="overflow: auto; max-height: 85vh; width: 100%;">
          <img :src="popupUrl" 
               @click="isZoomed = !isZoomed"
               :style="isZoomed ? 'width: 250%; max-width: none;' : 'max-width: 100%; max-height: 80vh;'"
               style="display: block; margin: auto; transition: all 0.3s ease;" />
        </div>
        <div class="text-center text-muted small mt-1">
          <span class="glyphicon glyphicon-zoom-in"></span> Tap image to zoom
        </div>
      </b-modal>
    </div>

  </label>
</template>

<script>
  import { Capacitor } from '@capacitor/core'
  import formUtils from '../../../utils/form_utils.js'
  import popup from './mixin_popup.js'
  export default{
    name: 'input-label',
    mixins:[popup],
    props:['label','elId','status','config', 'classes'],
    data(){
      return {
        showModal: false,
        isZoomed: false,
      }
    },
    computed: {
      labels(){return this.$store.state.labels},
      status_list(){return formUtils.status},
      isNative(){return Capacitor.isNativePlatform()},
      myclasses(){
        let rep = []
        if(this.status){
          rep=[ this.status_list?.[this.status]?.label_class ]
        }
        // if we have to add some classes
        if(this.classes){
          rep = rep.concat(this.classes)
        }
        return rep
      }
    }
  }
</script>
